import React, { useState } from 'react';
import { Play, Pause } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
interface AudioPlayerProps {
  duration: string;
  title?: string;
}
export function AudioPlayer({
  duration,
  title
}: AudioPlayerProps) {
  const {
    isLight
  } = useTheme();
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(35); // Mock progress
  return <div className={`backdrop-blur-xl rounded-xl border p-3 flex items-center gap-3 transition-colors duration-500 ${isLight ? 'bg-white/80 border-slate-200/60 shadow-sm' : 'bg-dark-card/60 border-white/10 shadow-lg'}`} data-id="element-588" data-mp="vq3j0d9evm9o">
      <button onClick={() => setIsPlaying(!isPlaying)} className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 border transition-colors ${isLight ? 'bg-slate-100 text-slate-700 hover:bg-slate-200 border-slate-200' : 'bg-white/10 text-white hover:bg-white/20 border-white/5'}`} data-id="element-589" data-mp="14qs05gu3q2qs">
        {isPlaying ? <Pause className="w-5 h-5 fill-current" data-id="element-590" data-mp="2p9f9xn27k2vs" /> : <Play className="w-5 h-5 fill-current ml-0.5" data-id="element-591" data-mp="2p72jelidwk74" />}
      </button>

      <div className="flex-1 space-y-1" data-id="element-592" data-mp="2u89rymscpneu">
        {title && <div className={`text-xs font-medium ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-593" data-mp="2z61wcga6n1zx">
            {title}
          </div>}
        <div className={`h-1.5 rounded-full overflow-hidden w-full ${isLight ? 'bg-slate-100' : 'bg-white/10'}`} data-id="element-594" data-mp="38wwfvcw1nnho">
          <div className={`h-full bg-vexu rounded-full transition-all duration-300 ${isLight ? '' : 'shadow-[0_0_8px_rgba(0,200,83,0.5)]'}`} style={{
          width: `${progress}%`
        }} data-id="element-595" data-mp="3cxgfqo80557i" />
        </div>
      </div>

      <div className={`text-xs font-medium w-10 text-right ${isLight ? 'text-slate-400' : 'text-zinc-500'}`} data-id="element-596" data-mp="1njjqd9ey0co5">
        {duration}
      </div>
    </div>;
}